/**
 * Lectures Timezone Cell - Frontend
 * @description Shows short timezone (e.g. GMT-3) for the lecture
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { LecturesTableData } from '@/types/operational-ui.types';
import { formatTimezoneShort } from '@/utils/formatters/timezoneFormatter';

export const LecturesTimezoneCell: React.FC<{
  info: CellContext<LecturesTableData, string | undefined>;
}> = ({ info }) => {
  const tz = info.getValue() ?? info.row.original.tz;
  return <div className="text-xs text-gray-600">{formatTimezoneShort(tz)}</div>;
};
